import { render, staticRenderFns } from "./homeV2.vue?vue&type=template&id=59544887&scoped=true&"
import script from "./homeV2.vue?vue&type=script&lang=js&"
export * from "./homeV2.vue?vue&type=script&lang=js&"
import style0 from "./homeV2.vue?vue&type=style&index=0&id=59544887&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59544887",
  null
  
)

export default component.exports